import { CwsA, CwsBreadcrumb, CwsBreadcrumbItem, CwsGridCol, CwsGridRow } from '@components/cws'
import type { FC } from 'react'
import Link from 'next/link'
import { useBreadCrumbsState } from '@components/BreadCrumbs/State/state'

export const BreadCrumbs: FC = () => {
  const {
    state: { breadcrumbs: breadcrumbsStory },
  } = useBreadCrumbsState()
  if (!breadcrumbsStory.length) return null
  return (
    <CwsGridCol col="12" className="cws-pt-s">
      <CwsGridRow justifyContent="left">
        <CwsGridCol>
          <CwsBreadcrumb>
            {breadcrumbsStory.map((bc, index, array) => {
              const isLast = index === array.length - 1
              if (isLast) {
                return (
                  <CwsBreadcrumbItem key={`${bc.title}-${index}`} current={isLast}>
                    <CwsA href={'#'} hideArrow>
                      {bc.title}
                    </CwsA>
                  </CwsBreadcrumbItem>
                )
              }
              return (
                <CwsBreadcrumbItem key={`${bc.title}-${index}`} current={isLast}>
                  <Link href={bc.href} passHref legacyBehavior>
                    <CwsA href={bc.href} hideArrow>
                      {bc.title}
                    </CwsA>
                  </Link>
                </CwsBreadcrumbItem>
              )
            })}
          </CwsBreadcrumb>
        </CwsGridCol>
      </CwsGridRow>
    </CwsGridCol>
  )
}

export default BreadCrumbs
